import { atomWithStorage } from 'jotai/utils';

export const hasMountedOnPdpAtom = atomWithStorage<boolean>('hasMountedOnPdp', false);
